<template>
  <div v-if="results && results.personal_abilities && results.personal_abilities.competences" class="row">
    <div class="col-md-8">
      <div class="d-flex align-center justify-space-between mt-4 mt-md-8">
        <h3 class="page-title">{{ personal_abilities.title }}</h3>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" class="d-inline-block">
              <v-btn v-if="$store.getters['auth/isAllowed']('recalculate_personal_abilities')"
                color="primary" class="px-0 mr-4 icon" outlined v-bind="attrs"
                @click="recalculatePersonalAbilities($route.params.id)"
                :loading="loading.calculatingPersonal"
              >
                <v-icon>mdi-calculator</v-icon>
              </v-btn>
              </div>
            </template>
          <span>Пересчитать</span>
        </v-tooltip>

      </div>
      <div class="compet-title-desc" v-html="prepareText(personal_abilities.description)"></div>
      <template v-if="allItems && allItems.length">
        <!-- <div class="compet-titles">
          <div class="col-6 pa-0">Характеристика</div>
          <div class="col-6 compet-title-2">Степень предрасположенности</div>
        </div> -->
        <PersonalAbilityRow v-for="(item,i) in allItems" :key="i" :item="item" />
      </template>
      <template v-else-if="topItems && topItems.length">
        <!-- <div class="compet-row__title">ВЫСОКОРАЗВИТЫЕ</div> -->
        <!-- <div class="compet-titles">
          <div class="col-6 pa-0">Характеристика</div>
          <div class="col-6 compet-title-2">Степень предрасположенности</div>
        </div> -->
        <PersonalAbilityRow v-for="(item,i) in topItems" :key="i" :item="item" />

        <!-- <div class="compet-row__title">НИЗКОРАЗВИТЫЕ</div> -->
        <!-- <div class="compet-titles">
          <div class="col-6 pa-0">Характеристика</div>
          <div class="col-6 compet-title-2">Степень предрасположенности</div>
        </div> -->
        <PersonalAbilityRow v-for="(item,i) in bottomItems" :key="i" :item="item" />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { prepareText } from '@/common/util';
import PersonalAbilityRow from './helpers/PersonalAbilityRow';

export default {
  name: 'PersonalAbilities',
  components: {
    PersonalAbilityRow
  },
  data: () => ({
  }),
  props: {
    shortReport: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapGetters({
      results: 'users/candidate/results',
      loading: 'users/candidate/loading',
    }),
    personal_abilities() {
      return this.results.personal_abilities ? this.results.personal_abilities : { title: '', description: '' };
    },
    sortedItems() {
      const arr = this.personal_abilities?.competences?.length ? [...this.personal_abilities.competences] : [];
      return arr.sort((a, b) => b.level - a.level);
    },
    allItems() {
      return !this.shortReport || this.sortedItems.length <= 10 ? this.sortedItems : null;
    },
    topItems() {
      return this.shortReport && this.sortedItems.length > 10 ? this.sortedItems.slice(0, 5) : null;
    },
    bottomItems() {
      return this.shortReport && this.sortedItems.length > 10 ? this.sortedItems.slice(-5) : null;
    },
  },
  methods: {
    ...mapActions({
      recalculatePersonalAbilities: 'users/candidate/recalculatePersonalAbilities',
    }),
    prepareText,
  },
};
</script>

<style>
.compet-titles {
    display: flex;
    font-weight: 600;
    margin: 20px 0;
}

.compet-title-desc {
    margin: 20px 0;
}

.compet-title-2 {
  padding: 0 0 0 55px;
}

@media screen and (max-width: 800px) {
  .compet-title-2 {
    padding: 0 0 0 0px;
  }
}

</style>
